import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ReportSideBarComponent } from './report-side-bar/report-side-bar.component';
import { ReportViewComponent } from './report-view/report-view.component';
import { ReportingService } from './reporting.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EditableModule,
        AnalyticsModule,
        TooltipModule,
        MatSlideToggleModule,
        RouterModule.forChild([])
    ],
    declarations: [ReportViewComponent, ReportSideBarComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [ReportingService]
})
export class ReportingModule {}
